module.exports = __webpack_public_path__ + "static/media/getFetch.5e98861f.cjs";